import {
  UserComment,
  UserCommentSearchFilter,
  UserCommentSearchResult,
  UserCommentWithRepliesSearchResult,
} from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentCommentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findCommentsForShipment(
    shipmentId: number,
    searchQuery: UserCommentSearchFilter,
  ): Promise<UserCommentWithRepliesSearchResult> {
    const response = await this.http.post(
      `${shipmentId}/comment/search`,
      searchQuery,
    );
    return new UserCommentWithRepliesSearchResult(response.data);
  }

  async findCommentCountForShipment(shipmentId: number): Promise<number> {
    const response = await this.http.get(`${shipmentId}/comment/count`);
    return response.data;
  }

  async findRepliesForComment(
    shipmentId: number,
    commentId: number,
    searchQuery: UserCommentSearchFilter,
  ): Promise<UserCommentSearchResult> {
    const response = await this.http.post(
      `${shipmentId}/comment/${commentId}/reply/search`,
      searchQuery,
    );
    return new UserCommentSearchResult(response.data);
  }

  async createComment(
    shipmentId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.post<UserComment>(
      `${shipmentId}/comment`,
      payload,
    );
    return new UserComment(response.data);
  }

  async replyToComment(
    shipmentId: number,
    commentId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.post<UserComment>(
      `${shipmentId}/comment/${commentId}/reply`,
      payload,
    );
    return new UserComment(response.data);
  }

  async updateComment(
    shipmentId: number,
    commentId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.put<UserComment>(
      `${shipmentId}/comment/${commentId}`,
      payload,
    );
    return new UserComment(response.data);
  }

  async deleteComment(shipmentId: number, commentId: number): Promise<void> {
    await this.http.delete(`${shipmentId}/comment/${commentId}`);
  }
}
